/* eslint-disable max-len */
import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="3" y="3" width="18" height="18" rx="4" />
    <path d="M10 8.4625C10.2581 8.30417 10.5357 8.1875 10.8328 8.1125C11.13 8.0375 11.4154 8 11.6891 8C12.1505 8 12.5533 8.08333 12.8974 8.25C13.2414 8.41667 13.5112 8.65 13.7067 8.95C13.9022 9.24167 14 9.59167 14 10C14 10.375 13.9296 10.7125 13.7889 11.0125C13.6559 11.3042 13.4839 11.575 13.2727 11.825C13.0694 12.075 12.8583 12.325 12.6393 12.575C12.4282 12.825 12.2444 13.0917 12.088 13.375C11.9316 13.6583 11.8377 13.9833 11.8065 14.35L11.7713 14.6125H11.1378V14.25C11.1378 13.825 11.1965 13.4583 11.3138 13.15C11.4311 12.8333 11.5758 12.55 11.7478 12.3C11.9277 12.05 12.1036 11.8125 12.2757 11.5875C12.4555 11.3542 12.6041 11.1167 12.7214 10.875C12.8387 10.6333 12.8974 10.3667 12.8974 10.075C12.8974 9.73333 12.784 9.4625 12.5572 9.2625C12.3304 9.0625 12.0176 8.9625 11.6188 8.9625C11.3685 8.9625 11.1026 9.00833 10.8211 9.1C10.5396 9.18333 10.2659 9.31667 10 9.5V8.4625ZM10.8094 17V15.6125H12.1114V17H10.8094Z" />
  </svg>
);
